// TeraMart Theme — v1.0.0
(function () {
  'use strict';

  // Mobile drawer toggle (+ hamburger morph)
  const drawer = document.querySelector('[data-mobile-drawer]');
  const drawerToggles = document.querySelectorAll('[data-drawer-toggle]');
  const setExpanded = (open) => {
    drawerToggles.forEach(b => b.setAttribute('aria-expanded', String(open)));
    document.body.style.overflow = open ? 'hidden' : '';
  };
  drawerToggles.forEach(btn =>
    btn.addEventListener('click', () => {
      if (!drawer) return;
      drawer.classList.toggle('is-open');
      setExpanded(drawer.classList.contains('is-open'));
    })
  );

  // Reveal-on-scroll with IntersectionObserver
  if ('IntersectionObserver' in window) {
    const revealTargets = document.querySelectorAll(
      '.section, .pb-card, .bc-row, .cat-tile, .hero-card, .promo-card, .mega-cat, .spotlight-card, .top-offer, .tech-drop, .pdp__fbt, .pdp__related, .pdp__recent, .category-tiles, .promise-strip, .brand-shop, .brand-logos, .certified-strip, .finance-banner, .featured-collection, .product-row__grid, .bc-main, .bc-sidebar, [data-reveal]'
    );
    revealTargets.forEach(el => el.classList.add('reveal'));
    const rv = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          rv.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealTargets.forEach(el => rv.observe(el));

    // Stagger groups
    document.querySelectorAll('.product-row__grid, .product-grid, .category-tiles, .promise-strip, .brand-shop, .collection-tiles, .footer-grid').forEach(el => {
      el.setAttribute('data-stagger', '');
      rv.observe(el);
    });
  }

  // Ripple position for buttons (CSS uses --mx / --my vars)
  document.addEventListener('pointermove', (e) => {
    const btn = e.target.closest ? e.target.closest('.btn') : null;
    if (!btn) return;
    const r = btn.getBoundingClientRect();
    btn.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
    btn.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
  });

  // Scrolled header shadow + bottom-nav active tracking
  const header = document.querySelector('.site-header, .site-header--pb');
  window.addEventListener('scroll', () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 4);
  }, { passive: true });

  // Animate bottom-nav underline based on scroll position for homepage
  document.querySelectorAll('.m-bottomnav__item').forEach(it => {
    it.addEventListener('click', () => {
      document.querySelectorAll('.m-bottomnav__item').forEach(x => x.classList.remove('is-active'));
      it.classList.add('is-active');
    });
  });

  // Success flash on add-to-cart forms (visual feedback; actual submit still happens)
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', () => {
      form.querySelectorAll('.btn--accent').forEach(b => {
        b.classList.add('is-added');
        setTimeout(() => b.classList.remove('is-added'), 900);
      });
    });
  });

  // Announcement bar auto-rotate
  const announcement = document.querySelector('[data-announcement]');
  if (announcement) {
    const items = announcement.querySelectorAll('.announcement-bar__item');
    if (items.length > 1) {
      let idx = 0;
      items.forEach((it, i) => (it.style.display = i === 0 ? 'inline-flex' : 'none'));
      setInterval(() => {
        items[idx].style.display = 'none';
        idx = (idx + 1) % items.length;
        items[idx].style.display = 'inline-flex';
      }, 4000);
    }
  }

  // Slideshow
  document.querySelectorAll('[data-slideshow]').forEach((el) => {
    const track = el.querySelector('.slideshow__track');
    const slides = el.querySelectorAll('.slide');
    const dotsWrap = el.querySelector('.slideshow__nav');
    if (!track || slides.length === 0) return;
    let current = 0;
    const autoplayMs = parseInt(el.dataset.autoplay || '6000', 10);

    // Dots
    const dots = Array.from(slides).map((_, i) => {
      const b = document.createElement('button');
      b.className = 'slideshow__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', () => go(i));
      dotsWrap?.appendChild(b);
      return b;
    });

    const go = (i) => {
      current = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === current));
    };
    if (autoplayMs > 0) {
      setInterval(() => go(current + 1), autoplayMs);
    }
  });

  // Product gallery thumbs
  document.querySelectorAll('[data-product-gallery]').forEach((el) => {
    const main = el.querySelector('.product__gallery-main img');
    const thumbs = el.querySelectorAll('.product__gallery-thumbs img');
    thumbs.forEach((t) =>
      t.addEventListener('click', () => {
        if (main) main.src = t.dataset.full || t.src;
        thumbs.forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
      })
    );
  });

  // Quantity input
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input[type="number"]');
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1') - 1);
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value || '1') + 1;
    });
  });

  // Promo hero arrows
  document.querySelectorAll('.promo-hero').forEach((el) => {
    const track = el.querySelector('.promo-hero__track, .slideshow__track');
    const slides = el.querySelectorAll('.promo-hero__slide');
    const prev = el.querySelector('.promo-hero__arrow--prev');
    const next = el.querySelector('.promo-hero__arrow--next');
    if (!track || slides.length === 0) return;
    let idx = 0;
    const go = (i) => {
      idx = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${idx * 100}%)`;
    };
    prev?.addEventListener('click', () => go(idx - 1));
    next?.addEventListener('click', () => go(idx + 1));
  });

  // Brand carousel (horizontal scroll with arrows)
  document.querySelectorAll('[data-carousel]').forEach((el) => {
    const track = el.querySelector('[data-carousel-track]');
    const prev = el.querySelector('[data-carousel-prev]');
    const next = el.querySelector('[data-carousel-next]');
    if (!track) return;
    const step = () => Math.max(200, track.clientWidth * 0.9);
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  // Countdown timers
  const pad = (n) => String(n).padStart(2, '0');
  document.querySelectorAll('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) return;
    const d = el.querySelector('[data-days]');
    const h = el.querySelector('[data-hours]');
    const m = el.querySelector('[data-minutes]');
    const s = el.querySelector('[data-seconds]');
    const tick = () => {
      let diff = Math.max(0, target - Date.now());
      const days = Math.floor(diff / 86400000); diff -= days * 86400000;
      const hrs = Math.floor(diff / 3600000); diff -= hrs * 3600000;
      const mins = Math.floor(diff / 60000); diff -= mins * 60000;
      const secs = Math.floor(diff / 1000);
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hrs);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(secs);
    };
    tick();
    setInterval(tick, 1000);
  });

  // Dark mode toggle
  const THEME_KEY = 'teramart_theme';
  const applyTheme = (t) => {
    document.documentElement.setAttribute('data-theme', t);
    document.querySelectorAll('[data-theme-label]').forEach(el => el.textContent = t === 'dark' ? 'Dark' : 'Light');
  };
  document.querySelectorAll('[data-theme-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const cur = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
      const next = cur === 'dark' ? 'light' : 'dark';
      applyTheme(next);
      try { localStorage.setItem(THEME_KEY, next); } catch(e) {}
    });
  });
  // Initial label sync based on what was applied by the inline script in <head>
  applyTheme(document.documentElement.getAttribute('data-theme') || 'light');

  // Predictive search
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = (cents) => 'A$' + (cents / 100).toFixed(2);

  document.querySelectorAll('[data-predictive-search]').forEach(form => {
    const input = form.querySelector('[data-predictive-input]');
    const wrap = form.querySelector('[data-predictive-results]');
    const inner = form.querySelector('[data-predictive-inner]');
    if (!input || !wrap || !inner) return;

    let debounce = null;
    let ctrl = null;

    const hide = () => { wrap.setAttribute('hidden', ''); };
    const show = () => { wrap.removeAttribute('hidden'); };

    const render = (q, data) => {
      const products = (data?.resources?.results?.products) || [];
      const queries = (data?.resources?.results?.queries) || [];
      if (!products.length && !queries.length) {
        inner.innerHTML = '<div class="predictive-results__noresults">No results for <strong>' + escapeHtml(q) + '</strong>. Try a different term.</div>';
        return;
      }
      let html = '';
      if (queries.length) {
        html += '<div class="predictive-results__section"><div class="predictive-results__heading">Suggestions</div>';
        queries.slice(0, 4).forEach(qq => {
          html += '<a class="predictive-results__suggestion" href="/search?q=' + encodeURIComponent(qq.text) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>' + qq.styled_text + '</a>';
        });
        html += '</div>';
      }
      if (products.length) {
        html += '<div class="predictive-results__section"><div class="predictive-results__heading">Products</div>';
        products.slice(0, 6).forEach(p => {
          const comp = p.compare_at_price_max && p.compare_at_price_max > p.price
            ? '<span class="predictive-results__item-compare">' + money(p.compare_at_price_max) + '</span>' : '';
          const img = p.image || (p.featured_image && p.featured_image.url) || '';
          html +=
            '<a class="predictive-results__item" href="' + p.url + '">' +
              '<img src="' + img + '" alt="' + escapeHtml(p.title) + '">' +
              '<div><div class="predictive-results__item-title">' + escapeHtml(p.title) + '</div>' +
                (p.vendor ? '<span class="predictive-results__item-vendor">' + escapeHtml(p.vendor) + '</span>' : '') + '</div>' +
              '<div><span class="predictive-results__item-price">' + money(p.price) + '</span>' + comp + '</div>' +
            '</a>';
        });
        html += '</div>';
        html += '<a class="predictive-results__viewall" href="/search?q=' + encodeURIComponent(q) + '">See all results for "' + escapeHtml(q) + '" →</a>';
      }
      inner.innerHTML = html;
    };

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(debounce);
      if (ctrl) ctrl.abort();
      if (q.length < 2) {
        inner.innerHTML = '<div class="predictive-results__empty">Start typing to see suggestions…</div>';
        show();
        return;
      }
      show();
      inner.innerHTML = '<div class="predictive-results__loading">Searching…</div>';
      debounce = setTimeout(async () => {
        ctrl = new AbortController();
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=last';
        try {
          const res = await fetch(url, { signal: ctrl.signal });
          if (!res.ok) throw new Error('search failed');
          const data = await res.json();
          render(q, data);
        } catch(e) {
          if (e.name !== 'AbortError') inner.innerHTML = '<div class="predictive-results__noresults">Search temporarily unavailable.</div>';
        }
      }, 220);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) show();
    });
    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) hide();
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { hide(); input.blur(); }
    });
  });

  // Collection: filter sidebar open/close on mobile
  const filterSidebar = document.querySelector('[data-filter-sidebar]');
  const filterBackdrop = document.querySelector('.collection-sidebar__backdrop');
  document.querySelectorAll('[data-filter-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      filterSidebar?.classList.add('is-open');
      filterBackdrop?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-filter-close]').forEach(btn => {
    btn.addEventListener('click', () => {
      filterSidebar?.classList.remove('is-open');
      filterBackdrop?.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  // Mobile: scroll-to-top FAB
  const topBtn = document.querySelector('[data-scroll-top]');
  if (topBtn) {
    topBtn.style.display = 'none';
    const onScroll = () => {
      topBtn.style.display = window.scrollY > 400 ? '' : 'none';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    topBtn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  // Mobile: hide floating Offers button when bottom nav area is in view (prevents overlap at page bottom)
  const fabs = document.querySelector('[data-mobile-fabs]');
  if (fabs) {
    let lastY = window.scrollY, hideTimer = null;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      // Hide on scroll down, show on scroll up
      if (y > lastY + 10 && y > 300) {
        fabs.classList.add('is-hidden');
      } else if (y < lastY - 10) {
        fabs.classList.remove('is-hidden');
      }
      lastY = y;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => fabs.classList.remove('is-hidden'), 800);
    }, { passive: true });
  }

  // Wishlist (localStorage-based)
  const WISHLIST_KEY = 'teramart_wishlist';
  const getWishlist = () => {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch(e) { return []; }
  };
  const setWishlist = (arr) => localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr));
  const updateWishlistCount = () => {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  };
  const refreshWishlistButtons = () => {
    const list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const handle = btn.dataset.productHandle;
      btn.classList.toggle('is-active', list.includes(handle));
    });
  };
  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const handle = btn.dataset.productHandle;
      let list = getWishlist();
      if (list.includes(handle)) list = list.filter(h => h !== handle);
      else list.push(handle);
      setWishlist(list);
      updateWishlistCount();
      refreshWishlistButtons();
    });
  });
  updateWishlistCount();
  refreshWishlistButtons();

  // Recently viewed renderer (reads handles from localStorage, fetches lightweight JSON from Shopify)
  const RECENT_KEY = 'teramart_recent';
  document.querySelectorAll('[data-recently-viewed-grid]').forEach(async (grid) => {
    let list = [];
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch(e) {}
    const currentHandle = document.querySelector('[data-product-handle]')?.dataset.productHandle;
    list = list.filter(h => h !== currentHandle).slice(0, 6);
    if (list.length === 0) {
      grid.closest('[data-recently-viewed-section]')?.setAttribute('hidden', '');
      return;
    }
    for (const handle of list) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) continue;
        const p = await res.json();
        const html = `
          <a href="${p.url}" class="pb-card">
            <div class="pb-card__media">
              <img src="${p.featured_image || ''}" alt="${p.title.replace(/"/g,'&quot;')}">
            </div>
            <div class="pb-card__body">
              <div class="pb-card__title">${p.title}</div>
              <div class="pb-card__price">
                ${p.compare_at_price && p.compare_at_price > p.price ? `<span class="pb-card__compare">A$${(p.compare_at_price/100).toFixed(2)}</span>`:''}
                <span class="pb-card__sale">A$${(p.price/100).toFixed(2)}</span>
              </div>
            </div>
          </a>`;
        grid.insertAdjacentHTML('beforeend', html);
      } catch(e) {}
    }
  });

  // Product page: variant selection (updates URL, label, price)
  document.querySelectorAll('.pdp__variant-options input[type=radio]').forEach(input => {
    input.addEventListener('change', () => {
      const group = input.closest('.pdp__variant-group');
      const label = group?.querySelector('[data-selected-value]');
      if (label) label.textContent = input.value;
      group?.querySelectorAll('.pdp__variant-option').forEach(opt => {
        opt.classList.toggle('is-selected', opt.contains(input));
      });
    });
  });

  // Product page: tabs
  document.querySelectorAll('[data-tabs]').forEach(wrap => {
    const tabs = wrap.querySelectorAll('[data-tab]');
    const panels = wrap.querySelectorAll('[data-panel]');
    tabs.forEach(t => t.addEventListener('click', () => {
      const name = t.dataset.tab;
      tabs.forEach(x => x.classList.toggle('is-active', x === t));
      panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === name));
    }));
  });

  // Product page: sticky ATC bar
  const sticky = document.querySelector('[data-sticky-atc]');
  const atc = document.querySelector('.pdp__atc');
  if (sticky && atc) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      });
    }, { rootMargin: '0px' });
    io.observe(atc);
  }

  // Product page: Frequently Bought Together total
  document.querySelectorAll('.pdp__fbt-form').forEach(form => {
    const totalEl = form.querySelector('[data-fbt-total]');
    const checks = form.querySelectorAll('input[type=checkbox]');
    const recompute = () => {
      let total = 0;
      checks.forEach(c => {
        if (!c.checked) return;
        const price = parseFloat(c.dataset.price);
        if (!isNaN(price)) total += price;
      });
      // Note: main item price lives in the submitted variant; approximate from rendered text
      const mainText = form.querySelector('.pdp__fbt-item--main span')?.textContent.replace(/[^\d.]/g,'');
      if (mainText) total += parseFloat(mainText) * 100;
      if (totalEl) totalEl.textContent = 'A$' + (total/100).toFixed(2);
    };
    checks.forEach(c => c.addEventListener('change', recompute));
  });

  // Fade-up on scroll
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('fade-up');
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.1 }
    );
    document.querySelectorAll('[data-animate]').forEach((el) => io.observe(el));
  }
})();
